/*
 * Paginação progressiva via Section Rendering API — substitui o infinite
 * scroll com cursor do collections.$handle.tsx e o comportamento append
 * do <Pagination> Hydrogen.
 *
 * Container: [data-paginated] com:
 *   data-mode="view"  → IntersectionObserver no [data-sentinel] (PLP)
 *   data-mode="click" → clique no link [data-next] (listas com Lottie)
 *   data-section-id, data-next-url, grade em [data-grid]
 */
function initContainer(container) {
  const mode = container.dataset.mode || 'view';
  const sectionId = container.dataset.sectionId;
  const grid = container.querySelector('[data-grid]');
  if (!grid || !sectionId) return;

  let nextUrl = container.dataset.nextUrl || null;
  let loading = false;

  async function loadNext() {
    if (!nextUrl || loading) return;
    loading = true;
    container.setAttribute('aria-busy', 'true');
    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const freshGrid = doc.querySelector('[data-grid]');
      if (freshGrid) {
        grid.append(...freshGrid.children);
      }

      const freshContainer = doc.querySelector('[data-paginated]');
      nextUrl = freshContainer?.dataset.nextUrl || null;
      if (!nextUrl) {
        container.removeAttribute('data-next-url');
        container.querySelector('[data-next]')?.remove();
      } else {
        container.dataset.nextUrl = nextUrl;
        const nextLink = container.querySelector('[data-next]');
        if (nextLink) nextLink.href = nextUrl;
      }
    } catch (error) {
      // Em caso de falha, deixa a navegação padrão (link/href) como fallback.
      nextUrl = null;
    } finally {
      loading = false;
      container.removeAttribute('aria-busy');
    }
  }

  if (mode === 'view') {
    const sentinel = container.querySelector('[data-sentinel]');
    if (!sentinel) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) loadNext();
      });
    });
    observer.observe(sentinel);
  } else {
    container.addEventListener('click', (event) => {
      const nextLink = event.target.closest('[data-next]');
      if (!nextLink) return;
      event.preventDefault();
      loadNext();
    });
  }
}

function init() {
  document.querySelectorAll('[data-paginated]').forEach(initContainer);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
